var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrepareProductIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8031 4.36924C17.7098 4.25346 17.5917 4.16016 17.4575 4.09624C17.3232 4.03233 17.1764 3.99944 17.0277 4.00001H6.97231C6.82364 3.99944 6.67675 4.03233 6.54253 4.09624C6.4083 4.16016 6.29018 4.25346 6.19692 4.36924L4 8.44308H20L17.8031 4.36924ZM4 19.0769C4 19.3217 4.09725 19.5565 4.27036 19.7296C4.44347 19.9027 4.67826 20 4.92308 20H19.0769C19.3217 20 19.5565 19.9027 19.7296 19.7296C19.9027 19.5565 20 19.3217 20 19.0769V9.53847H4V19.0769ZM7.69231 12.3077H12.6154V13.5385H7.69231V12.3077ZM7.69231 14.7692H15.0769V16H7.69231V14.7692Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepareProductIcon);
export default __webpack_public_path__ + "static/media/prepare-product-icon.1cb12417.svg";
export { ForwardRef as ReactComponent };